import { deleteCookies } from './deleteCookies'

export const cookiesActions = {
  deleteCookies,
}
